export interface ICmsAlbum {
  id?: string | null;
  title?: string | null;
  version?: string | null;
  additionalVersions?: ICmsAdditionalVersion[] | null;
  primaryContributor?: string | null;
  contributors?: ICmsContributor[] | null;
  metadataLanguage?: ICmsReferenceField | null;
  organization: ICmsOrganization;
  copyrightYear?: number | null;
  copyrightLine?: string | null;
  phonographicCopyrightYear?: number | null;
  phonographicCopyrightLine?: string | null;
  tracks?: ICmsTrack[] | null;
  productType?: string | null;
  catalogNumber?: string | null;
  internalDescription?: string | null;
  releaseDate?: string | null;
  originalReleaseDate?: string | null;
  submissionState?: CmsSubmissionState | null;
  submissionSource?: string | null;
  preorderStartDate?: string | null;
  wholesalePriceTier?: string | null;
  displayCopyrightLine?: string | null;
  explicitLyrics?: boolean | null;
  displayPhonographicCopyrightLine?: string | null;
  exclusiveRetailer?: string | null;
  exclusiveReleaseDate?: string | null;
  videoTrack?: ICmsTrack | null;
  volumes?: number | null;
  taxonomy?: ICmsGenre | null;
  idTypes?: ICmsIdTypes | null;
}

export interface ICmsOrganization extends ICmsReferenceField {
  orgAdminId?: string | null;
  parentOrgId?: number | null;
  parentOrgName?: string | null;
  parentOrgAdminId?: string | null;
}

export interface ICmsAdditionalVersion {
  version?: string | null;
}

export interface ICmsTrack {
  trackNumber: number;
  discNumber: number;
  title?: string | null;
  version?: string | null;
  contributors?: ICmsContributor[] | null;
  displayedArtist?: string | null;
  idTypes?: ICmsTrackIds | null;
  publishers?: ICmsPublisher[] | null;
  audioDuration?: number | null;
  additionalVersions?: ICmsAdditionalVersion[] | null;
  producers?: ICmsProducer[] | null;
}

export interface ICmsTrackIds {
  isrc?: string | null;
}

export interface ICmsPublisher {
  name?: string | null;
  collectioner?: string | null;
}

export interface ICmsContributor {
  name?: string | null;
  role: CmsContributorRole;
}

export interface ICmsGenre {
  displayName?: string | null;
  masterGenre?: string | null;
  reference?: string | null;
}

export interface ICmsReferenceField {
  reference?: string | null;
  displayName?: string | null;
}

export interface ICmsProducer {
  name?: string | null;
}

export enum CmsContributorRole {
  Unknown = 'Unknown',
  MainArtist = 'MainArtist',
  FeaturedArtist = 'FeaturedArtist',
  Writer = 'Writer',
  Composer = 'Composer',
  WriterComposer = 'WriterComposer',
  Remixer = 'Remixer',
}

export const enum CmsSubmissionState {
  QCEditApproved = 'QCEditApproved',
  QCApproved = 'QCApproved',
  Draft = 'Draft',
  Invalid = 'Invalid',
  Rejected = 'Rejected',
  QCPendingReview = 'QCPendingReview',
  QCUnderReview = 'QCUnderReview',
  QCAnalyzing = 'QCAnalyzing',
  PendingINDMAImport = 'PendingINDMAImport',
  Error = 'Error',
  Imported = 'Imported',
  Paused = 'Paused',
  Released = 'Released',
  Deleted = 'Deleted',
  Reviewed = 'Reviewed',
  External = 'External',
}

export interface ICmsIdTypes {
  gtin?: number | null;
  stringGtin?: string | null;
  indmaGtin?: string | null;
  isrc?: string | null;
  grid?: string | null;
  customId?: string | null;
}
